/** Slug rule of the backend: 3–64 of `a-z`, `0-9`, `-`, not starting or ending with `-`. */
export const TENANT_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{1,62}[a-z0-9]$/;
export const TENANT_SLUG_MAX_LENGTH = 64;

/**
 * Suggests a slug from a tenant name: accents dropped (Vietnamese `đ` too),
 * lowercase, every other run of characters turned into one hyphen.
 */
export function slugifyTenantName(name: string): string {
	return name
		.normalize('NFD')
		.replace(/[̀-ͯ]/g, '')
		.replace(/đ/gi, 'd')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.slice(0, TENANT_SLUG_MAX_LENGTH)
		.replace(/-+$/, '');
}
